import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import IndexPage from 'flarum/forum/components/IndexPage';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import AskQuestion from './models/AskQuestion';
import AskQuestionModal from './components/AskQuestionModal';
import AskFloatingButton from './components/AskFloatingButton';
import AskHumanRefundedNotification from './components/AskHumanRefundedNotification';

app.initializers.add('taro-ask', () => {
  app.store.models['taro-ask-questions'] = AskQuestion;

  // 退款通知组件
  app.notificationComponents['askHumanRefunded'] = AskHumanRefundedNotification;

  // 注册全局访问点，供 taro-ai 的 TextSelectionTrigger 调用
  app.askQuestionModal = {
    open({ selectedText, discussionId, postId, articleId }) {
      return app.modal.show(AskQuestionModal, {
        selectedText,
        discussionId,
        postId,
        articleId,
      });
    },
  };

  // 全局挂载提问答疑悬浮按钮
  extend(IndexPage.prototype, 'oncreate', function () {
    mountAskFloatingButton();
  });

  extend(DiscussionPage.prototype, 'oncreate', function () {
    mountAskFloatingButton();
  });

  // 其他页面（如文章页）的 fallback
  setTimeout(mountAskFloatingButton, 500);
});

let mounted = false;

function mountAskFloatingButton() {
  if (mounted) return;
  mounted = true;

  const container = document.createElement('div');
  container.className = 'AskFloatingButton-wrapper';
  document.body.appendChild(container);
  m.mount(container, AskFloatingButton);
}
